import { Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthFactoryService } from '../../authFactory.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-signin',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  endpoint$: Observable<string>;
  open$: Observable<boolean>;

  constructor(private authFactoryService: AuthFactoryService, public sanitizer: DomSanitizer) {}

  @HostListener('window:message', ['$event']) onMessage(event) {
    this.receiveMessage(event);
  }

  ngOnInit() {
    this.endpoint$ = this.authFactoryService.getEndpoint();
    this.open$ = this.authFactoryService.getOpenSignIn();
  }

  receiveMessage(event: MessageEvent) {
    if (typeof event.data === 'string') {
      this.authFactoryService.dispatchSaveToken(event.data);
    }
  }
}
